import flagship from '@flagship.io/js-sdk';
import Logger from './common/safe-log';
import { timestampTxt } from './lib/utils';

let env = process.env.stage || 'dev';
let FLAGSHIP_ENV_ID = 'bv3vbe0fmthg55le9ee0'; // pre-prod
let FLAGSHIP_API_KEY = 't5p7wiC4qkao4mdNT1rUZgdv3yvnmnX37MWKfzB2'; // pre-prod

if (env === 'prod') {
    FLAGSHIP_ENV_ID = 'bv3vbe0fmthg55le9edg'
    FLAGSHIP_API_KEY = 'Wq0KCSA2br2MOlcliFK2RawsCBhDwzcF9ICk89g3'
}

const AbTasty = {
    debug: true,
    ENV_ID: process.env.FLAGSHIP_ENV_ID || FLAGSHIP_ENV_ID,
    API_KEY: process.env.FLAGSHIP_API_KEY || FLAGSHIP_API_KEY,
    init: function (visitor) {
        try {
            Logger.debug(`${timestampTxt()} - Initializing AbTasty env=${env}`);
            const fsInstance = flagship.start(AbTasty.ENV_ID, AbTasty.API_KEY, {
                enableClientCache: true,
                enableConsoleLogs: true,
                decisionMode: 'API',
                timeout: 15
            });
            const fsVisitorInstance = fsInstance.newVisitor(visitor.userId, visitor);
            Logger.debug(`${timestampTxt()} - ABTasty Initialized`, { fsVisitorInstance });
            return fsVisitorInstance;
        } catch (e) {
            // handle errors
            Logger.error('Failed to initialize AbTasty', e);
        }
    },
};


export default AbTasty
